import React, { useState } from 'react'
import { Card, CardContent } from '../../components/ui/card'
import { goToHomePage, hideLoader, showLoader } from '../../helpers/Utils'
import { Input } from '../../components/ui/input'
import { Button } from '../../components/ui/button'
import { Label } from '../../components/ui/label'
import '../../assets/styleSheets/login.scss'
import { CDN_URL } from '../../constants/siteConstant'
import { useTranslation } from 'react-i18next'

const errorStyle = {
  fontSize: '12px',
  color: 'red',
  marginTop: '4px'
}
export default function LoginNew ({ authActions }) {
  const [loginData, setLoginData] = useState({
    email: '',
    password: ''
  })
  const [validationErrors, setValidationErrors] = useState({
    email: '',
    password: ''
  })
  const [showPassword, setShowPassword] = useState(false)
  const { t } = useTranslation(['auth'])

  const handleChange = (event) => {
    setLoginData({ ...loginData, [event.target.name]: event.target.value })
    setValidationErrors({ ...validationErrors, [event.target.name]: '' })
  }

  const handleSubmit = (event) => {
    event.preventDefault()
    showLoader()
    const errors = {}
    if (!loginData.email.trim()) {
      errors.email = t('emailRequired')
    }
    if (!loginData.password.trim()) {
      errors.password = t('passwordRequired')
    }
    if (Object.keys(errors).length === 0) {
      authActions.tryLoginWithEmail(loginData)
      hideLoader()
    } else {
      hideLoader()
      setValidationErrors(errors)
    }
  }

  function handleKeyPress (event) {
    if (event.key === 'Enter') {
      event.preventDefault()
      handleSubmit()
    }
  }

  const togglePassword = () => {
    setShowPassword(!showPassword)
  }

  return (
    <div className='login-container'>
      <div className='logo' onClick={goToHomePage} />
      <Card className='login-card p-8'>
        <div
          className='login-left flex-center flex-d-column'
          style={{
            backgroundImage: `url('${CDN_URL}/workshop-portal/static-images/login-bg.svg')`,
            backgroundSize: 'cover',
            backgroundPosition: 'center'
          }}
        >
          <div className='font-weight-700 gp-text24 text-white tracking-0 gp-lh28 gp-mb20'>{t('pageTitle')}</div>
          <p>{t('pageSubtitle')}
          </p>
        </div>
        <CardContent className='login-right' style={{ padding: '3rem 1.5rem' }}>
          <h2 className='font-weight-700 gp-text24 tracking-0 gp-lh28 gp-mb8'>Login</h2>
          <p className='subheading'>
            {t('loginUseHelloparts')}
          </p>

          <div className='form-group gp-mb16'>
            <Label htmlFor='email' className='gp-mb8 required'>E-Mail</Label>
            <Input
              id='email'
              name='email'
              type='email' placeholder='Ihre E-Mail Adresse'
              onChange={handleChange}
            />
            <span style={errorStyle}>{validationErrors.email || ''}</span>
          </div>

          <div className='form-group'>
            <Label htmlFor='password' className='gp-mb8 required'>{t('password')}</Label>
            <div className='password-wrapper'>
              <Input
                id='password'
                name='password'
                type={showPassword ? 'text' : 'password'}
                placeholder='*************'
                onKeyPress={handleKeyPress}
                onChange={handleChange}
              />
              <span style={errorStyle}>{validationErrors.password || ''}</span>
              <img
                src={
                  showPassword
                    ? `${CDN_URL}/workshop-portal/icons/eye-thin.svg`
                    : `${CDN_URL}/workshop-portal/icons/eye-close-thin.svg`
                }
                onClick={togglePassword}
                alt='Toggle visibility'
                className='toggle-password-icon'
              />
            </div>
          </div>

          <Button
            className='login-button bg-[#6926D9]'
            onClick={handleSubmit}
          >{t('loginBtn')}
          </Button>

          <p className='password-reset'>
            {t('forgotPWDHeader')} <a href='/forgot-password'>{t('requestPwReset')}</a>
          </p>
        </CardContent>
      </Card>
    </div>
  )
}
